import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { PartnersModel } from './partners.model';
import { SharedService } from '../../../../shared/services/shared.service';
import { PartnersFormComponent } from './partners-form.component';
import { PartnersService } from './partners.service';

@Component({
    selector: 'convfact-dialogImportAccountSocios',
    templateUrl: './partners-dialog-importAccount.component.html',
    styleUrls: ['./partners-form.component.css'],
    standalone: false
})
export class PartnerDialogImportAccount {

    importMovements: any = this.data.importMovements;
    dataImport: PartnersModel = this.data.dataImport;

    constructor(
        public dialogRef: MatDialogRef<PartnersFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar,
        public partnerService: PartnersService,
        public sharedService: SharedService
    ) { }

    startImport() {
        this.sharedService.importAccountsUpdate(this.dataImport, "Socios").then(result => {
            this.dialogRef.close();
        });
    }

    closeDialog() {
        this.dialogRef.close();
    }




}
